module.exports = require("/tmp/build_cb382eef/src/lib/gatsby/gatsby-browser.tsx");